var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "17px",
    viewBox: "0 0 15 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BF1594D3-4ABD-45FA-A328-F8B7C3E3196F@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Workout-Builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Templates",
    transform: "translate(-23.000000, -427.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47",
    transform: "translate(23.000000, 425.455265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_integration_3549923",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,15 C4.88071187,15 6,13.8807119 6,12.5 C6,11.1192881 4.88071187,10 3.5,10 C2.11928813,10 1,11.1192881 1,12.5 C1,13.8807119 2.11928813,15 3.5,15 Z M3.5,11.3636364 C4.12759631,11.3636364 4.63636364,11.8724037 4.63636364,12.5 C4.63636364,13.1275963 4.12759631,13.6363636 3.5,13.6363636 C2.87240369,13.6363636 2.36363636,13.1275963 2.36363636,12.5 C2.36363636,11.8724037 2.87240369,11.3636364 3.5,11.3636364 L3.5,11.3636364 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,3.5 C14,2.11928813 12.8807119,1 11.5,1 C10.1192881,1 9,2.11928813 9,3.5 C9,4.88071187 10.1192881,6 11.5,6 C12.8807119,6 14,4.88071187 14,3.5 Z M10.3636364,3.5 C10.3636364,2.87240369 10.8724037,2.36363636 11.5,2.36363636 C12.1275963,2.36363636 12.6363636,2.87240369 12.6363636,3.5 C12.6363636,4.12759631 12.1275963,4.63636364 11.5,4.63636364 C10.8724037,4.63636364 10.3636364,4.12759631 10.3636364,3.5 L10.3636364,3.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2264348,13.260274 L10.0653862,16 L11.159673,14.9439601 L9.64212438,13.4794521 L12.1610486,13.4794521 C12.9139853,13.4794521 13.6360837,13.1908032 14.1684904,12.6770049 C14.700897,12.1632066 15,11.4663465 15,10.739726 L15,8 L13.451481,8 L13.451481,10.739726 C13.451481,11.4275028 12.8737347,11.985056 12.1610486,11.985056 L9.64212438,11.985056 L11.159673,10.5205479 L10.0653862,9.46450809 L7.2264348,12.2042341 C6.92452173,12.4959577 6.92452173,12.9685504 7.2264348,13.260274 L7.2264348,13.260274 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5.26027397 L0,8 L1.54851896,8 L1.54851896,5.26027397 C1.54851896,4.5724972 2.12626526,4.01494396 2.83895143,4.01494396 L5.35787562,4.01494396 L3.84032703,5.47945205 L4.93461377,6.53549191 L7.7735652,3.79576588 C8.07547827,3.50404229 8.07547827,3.03144961 7.7735652,2.73972603 L4.93461377,0 L3.84032703,1.05603985 L5.35787562,2.52054795 L2.83895143,2.52054795 C1.27104185,2.52054795 0,3.74716507 0,5.26027397 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.d750b74e58342a01db244f15d542e187.svg";
export { ForwardRef as ReactComponent };